<template>
  <div class="container archiv">
    <div class="fullscreen_background">
        <img src="/static/assets/archiv_19-06/Hintergrund_2860.jpg" />
    </div>

    <top-menu />
    <top-logo />
    <stoppuhr />
    <copyright />
    <lautsprecher />

    <div class="stickerheft_slider">
    </div>

    <!--router-link to="/spacegeschichten" tag="div" class="raketepointer"-->
    <div class="rakete pointer"  @click="space">
      <img class="img" src="/static/assets/archiv_19-06/Rakete.png" />
    </div>
    <!--/router-link-->
    <!--router-link to="/wassergeschichten" tag="div" class="meerjungfrau pointer"-->
    <div class="meerjungfrau pointer"  @click="wasser">
      <img class="img" src="/static/assets/archiv_19-06/Meerjungfrau.png" />
    </div>
    <!--/router-link-->
    <!--router-link to="/junglegeschichten" tag="div" class="jungle pointer"-->
    <div class="jungle pointer" @click="jungle">
      <img class="img" src="/static/assets/archiv_19-06/Safari.png" />
    </div>
    <!--/router-link-->
    <div class="stickerheft_slider">
      <div class="heft_ausgabe_1801 hovering">
      <img class="img" src="/static/assets/archiv_19-06/archiv_stickerheft_A03019.png" />
    </div>
	<router-link to="/archiv4" tag="div" class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/archiv_18-12/Pfeil_rechts.png" />
    </router-link>
	<router-link to="/archiv2" tag="div" class="pfeil_links_big z50 pointer">
        <img class="img" src="/static/assets/archiv_19-06/Pfeil_links.png" />
    </router-link>
      <div class="ausgabetitel">
      <img class="img" src="/static/assets/archiv_19-06/Ausgabe_2019_03.png" />
    </div>
     <div class="stoerer">
      <img class="img" src="/static/assets/archiv_19-06/Stoerer_blau_Archiv.png" />
    </div>
    </div>
  </div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'Archiv3',
  data () {
    return {
      who: 'Archiv3'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright
  },
  mounted () {
    this.$ga.page(this.$router)
  },
  methods: {
    space() {
      var muted = (typeof window.muted === 'undefined' ? false : window.muted)
      console.log(typeof window.currentAudio)
      try {
        window.currentAudio.pause()
        window.currentAudio.currentTime = 0
        window.currentAudio = null
      } catch (e) {
        console.log('current audio geht nicht')
      }
      window.currentAudio = new Audio('/static/assets/sounds/01_Frontpage/SFX/Hugidubies_Archivseite_Dubix_Titel_Sternenritter.mp3')
      window.currentAudio.muted = muted
      window.currentAudio.play()
      var self = this
      setTimeout(function () {
        self.$root.$router.push('/spacegeschichten')
      }, 2500)
    },
    wasser () {
      try {
        window.currentAudio.pause()
        window.currentAudio.currentTime = 0
        window.currentAudio = null
      } catch (e) {}
      var muted = (typeof this.$root.muted !== 'undefined' ? this.$root.muted : false)
      window.currentAudio = new Audio('/static/assets/sounds/01_Frontpage/SFX/Hugidubies_Archivseite_Gigi_Titel_Anemonia.mp3')
      window.currentAudio.muted = muted
      window.currentAudio.play()
      var self = this
      setTimeout(function () {
        self.$root.$router.push('/wassergeschichten')
      }, 2000)
    },
    jungle () {
      var muted = (typeof window.muted === 'undefined' ? false : window.muted)
      try {
        window.currentAudio.pause()
        window.currentAudio.currentTime = 0
        window.currentAudio = null
      } catch (e) {}
      window.currentAudio = new Audio('/static/assets/sounds/01_Frontpage/SFX/Hugidubies_Archivseite_Hugi_Titel_Forscher.mp3')
      window.currentAudio.muted = muted
      window.currentAudio.play()
      var self = this
      setTimeout(function () {
        self.$root.$router.push('/junglegeschichten')
      }, 1500)
    }
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
      window.hintergrundSound.pause()
    } catch (e) {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {margin:0; padding:0;}

/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}

.pointer {cursor: pointer;}
.rakete{
    position: absolute;
    bottom: 58%;
    right: 13%;
}
.rakete{animation: rakete_erscheint 0.5s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes rakete_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.meerjungfrau {
    position: absolute;
    bottom: 38%;
    right: 14%;
}
.jungle {animation: jungle_erscheint 0.5s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes jungle_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.jungle {
    position: absolute;
    bottom: 16%;
    right: 14%;
}
.meerjungfrau {animation: meerjungfrau_erscheint 0.5s ease-out; animation-delay: 0.75s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes meerjungfrau_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.stickerheft_slider {
    position: absolute;
    bottom: 5%;
    left: 11%;
}

.pfeil_links_big {
    position: absolute;
    top: 39%;
    left: 4%;
}
.pfeil_rechts_big {
    position: absolute;
    top: 39%;
    left: 90%;
}
.ausgabetitel {
    position: absolute;
    bottom: 7%;
    text-align: center;
    width: 100%;
}
.heft_ausgabe_1801 img{animation: heft_ausgabe_1801_erscheint 0.5s ease-out; animation-delay: 0.25s; animation-fill-mode: forwards; opacity:0; transform-origin:center center;}
@keyframes heft_ausgabe_1801_erscheint {
    0% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
@-webkit-keyframes hovering2 /* Safari and Chrome */ {
   0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
 50% {
    -ms-transform: translate(0px,20px);
    -moz-transform: translate(0px,20px);
    -webkit-transform: translate(0px,20px);
    -o-transform: translate(0px,20px);
    transform: translate(0px,20px);
  }
 100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering2 {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
 50% {
    -ms-transform: translate(0px,20px);
    -moz-transform: translate(0px,20px);
    -webkit-transform: translate(0px,20px);
    -o-transform: translate(0px,20px);
    transform: translate(0px,20px);
  }
 100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
	
.archiv .hovering {
  -webkit-animation: hovering2 8s ease-in-out infinite;
  -moz-animation: hovering2 8s ease-in-out infinite;
  -ms-animation: hovering2 8s ease-in-out infinite;
  -o-animation: hovering2 8s ease-in-out infinite;
  animation: hovering2 8s ease-in-out infinite;
}
  .stoerer {
    position: absolute;
    top: 490px;
    left: 530px;
}
.pfeil_links_big.z50.pointer {
    position: absolute;
    top: 39%;
    left: 4%;
}
.stoerer {
    animation: stoerer_animation 18s infinite;
  animation-delay: 2s;
    opacity:0;
}
@keyframes stoerer_animation {
    0% { opacity:0; }
    10% { opacity:0; }
    20% { opacity:1; }
    35% { opacity:1; }
    45% { opacity:1; }
    65% { opacity:0; }
    75% { opacity:0; }
    100% { opacity:0; }
  }
</style>



// WEBPACK FOOTER //
// src/components/Archiv3.vue